module.exports = __webpack_public_path__ + "static/media/help-and-support.b2b43026.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/home/sections/marketingPoints/assets/help-and-support.png
 ** module id = 569
 ** module chunks = 0
 **/